import * as styled from './CameraPlaceholder.styles';
import Close from '~components/svgs/Close';
import Loading from '~components/dumbs/Loading';
import { FuelTypography } from '@frete.com/fuel-react';

function Camera({ onClickClose }: { onClickClose?: () => void }) {
  return (
    <styled.Wrapper>
      <styled.CloseButton onClick={onClickClose} type="button">
        <Close />
      </styled.CloseButton>

      <styled.Placeholder>
        <styled.LoadingPositioner>
          <Loading />
          <FuelTypography>Carregando câmera</FuelTypography>
        </styled.LoadingPositioner>
      </styled.Placeholder>
    </styled.Wrapper>
  );
}

export default Camera;
